import { Component, OnInit, ElementRef, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { ROUTES } from '../sidebar/sidebar.component';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from 'app/core/authentication/authentication.service';
import { Account } from 'app/shared/models/account';
import { filter } from 'rxjs';
import { AboutService } from 'app/core/services/about.service';
import { TourService } from 'app/core/services/tour.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit, AfterViewInit {
  private listTitles: any[];
  location: Location;
  accountInfo: Account;

  public isCollapsed = true;

  @Output() sidebarToggleClick = new EventEmitter<void>();

  constructor(location: Location, private element: ElementRef, private router: Router, private authService: AuthService,
    private about: AboutService, private tourService: TourService) {
    this.location = location;
  }

  ngOnInit() {
    this.listTitles = ROUTES.filter(listTitle => listTitle);
    const supervisorMode = localStorage.getItem('account');
    if ((supervisorMode)) {
      this.accountInfo = JSON.parse(supervisorMode);
    }
  }

  ngAfterViewInit() {
  }

  collapse() {
    this.isCollapsed = !this.isCollapsed;
    const navbar = document.getElementsByTagName('nav')[0];
    console.log(navbar);
    if (!this.isCollapsed) {
    } else {
    }

  }

  getTitle() {
    var titlee = this.location.prepareExternalUrl(this.location.path());
    if (titlee.charAt(0) === '#') {
      titlee = titlee.slice(2);
    }
    titlee = titlee.split('/').pop();

    for (var item = 0; item < this.listTitles.length; item++) {
      if (this.listTitles[item].path === titlee) {
        return this.listTitles[item].title;
      }
    }
    return 'Dashboard';
  }

  async logout() {
    try {
      await this.authService.logout();
    } catch (error) {
      console.error('Logout failed:', error);
    }
  }

  startTour() {
    this.tourService.start([
      { elementId: 'dashboard',       route: '/dashboard', title: 'Dashboard',             description: 'Your command center — monitor attendance, approvals, and payroll analytics all in one place.' },
      { elementId: 'tour-filter',     route: '/dashboard', title: 'Filters',               description: 'Filter dashboard data by department, branch, or employee to narrow down what you see.' },
      { elementId: 'tour-infobar',    route: '/dashboard', title: 'Info Bar',              description: 'Shows the live clock, current date, active payroll period, and estimated period cost.' },
      { elementId: 'tour-metrics',    route: '/dashboard', title: 'Attendance Summary',    description: "Today's headcount at a glance — present, late, absent, rest day, and total employee count." },
      { elementId: 'tour-approvals',  route: '/dashboard', title: 'Approval Requests',     description: 'Review and act on pending leave, loan, and change schedule requests from your team.' },
      { elementId: 'tour-charts',     route: '/dashboard', title: 'Annual Statistics',     description: 'Visual charts for hours worked by client, overtime vs allowed, salary computations, and lates & absences.' },
      { elementId: 'sidebar',                              title: 'Sidebar Navigation',    description: 'Use the sidebar to move between modules. The search bar at the top lets you jump to any page instantly.' },
      { elementId: 'payroll-expense',                      title: 'Payroll & Expense',     description: 'Process timesheets, run payroll, manage loans, reimbursements, deductions, and adjustments.' },
      { elementId: 'employee',                             title: 'Employee',               description: 'Manage employee records, attendance, schedules, leave requests, and biometric verification.' },
      { elementId: 'payroll-setup',                        title: 'Payroll Setup',          description: 'Configure your payroll structure — charges, salary scales, concepts, definitions, and departments.' },
      { elementId: 'reports',                              title: 'Reports',                description: 'Generate operational and compliance reports: payroll summaries, leave, DTR, SSS, PhilHealth, and more.' },
      { elementId: 'workflows',                            title: 'Workflows',              description: 'Visual diagram of the end-to-end payroll process to guide your scheduled processing steps.' },
      { elementId: 'support',                              title: 'Support Ticket',         description: 'Need help? Submit a support ticket here and our team will respond as soon as possible.' },
    ]);
  }

  startTourPersonal() {
    this.tourService.start([
      { elementId: 'sidebar',            route: '/home',              title: 'Sidebar',             description: 'Navigate through Time Management, Leave Application, and Reimbursement.' },
      { elementId: 'time-tracker',       route: '/home',              title: 'Attendance Tracker',   description: 'Monitor your current attendance status, date, and time tracking.' },
      { elementId: 'timesheet',          route: '/home',              title: 'Generate Timesheet',   description: 'Generate your timesheet for the selected period to view logged hours.' },
      { elementId: 'holiday',            route: '/home',              title: 'Upcoming Holidays',    description: 'Displays upcoming holidays to keep track of non-working days.' },
      { elementId: 'time-management',    route: '/time-management',   title: 'Time Management',      description: 'Track attendance, clock in/out, and view work hours over a period.' },
      { elementId: 'calendar',           route: '/time-management',   title: 'Calendar',             description: 'View and manage your attendance. Click or drag to add attendance.' },
      { elementId: 'leave-application',  route: '/apply-leave',       title: 'Leave Application',    description: 'Submit leave requests and review previous leave application statuses.' },
      { elementId: 'reimbursement',      route: '/reimbursement-form',title: 'Reimbursements',       description: 'Manage reimbursement requests and view submitted form statuses.' },
    ]);
  }
  isInTimeManagementComponent() {
    return this.router.url.includes('/time-management');
  }
  isInLeaveComponent() {
    return this.router.url.includes('/apply-leave');
  }
  isInReimbursementComponent() {
    return this.router.url.includes('/reimbursement-form');
  }
  openChat() {
    this.router.navigate(['/chat-section']);
  }
  aboutDialog() {
    const dialogData = {

    };

    this.about.openDialog(dialogData).subscribe((result) => {
      if (result) {
        console.log('Logout confirmed' + result);
      }
    });
  }
}
